import Icon from '../Icon/Icon'
import { Icons } from '@/utils/Icons'

export default function Spinner() {
    return <Icon width={'21'} height={'21'} name={Icons.Spinner} />
}